// Reusable colour palette for map nodes and keyword chips (ids kept stable for saved data).
export const PALETTE = [
  { id: "stone",    label: "Cotton",    hex: "#7A6A8C", bg: "#F6F1FA", fg: "#5E4B70", dot: "bg-[#F6F1FA] border-[#7A6A8C]" },
  { id: "burgundy", label: "Bubblegum", hex: "#E0478A", bg: "#FDE4F0", fg: "#A81E5C", dot: "bg-[#FDE4F0] border-[#E0478A]" },
  { id: "forest",   label: "Lavender",  hex: "#8B5CF6", bg: "#EDE7FE", fg: "#5B32C2", dot: "bg-[#EDE7FE] border-[#8B5CF6]" },
  { id: "ochre",    label: "Peach",     hex: "#F08A5D", bg: "#FFEADF", fg: "#A8482A", dot: "bg-[#FFEADF] border-[#F08A5D]" },
  { id: "slate",    label: "Sky",       hex: "#5B9BE6", bg: "#E3F0FD", fg: "#22599A", dot: "bg-[#E3F0FD] border-[#5B9BE6]" },
  { id: "plum",     label: "Grape",     hex: "#B455C9", bg: "#F6E3FA", fg: "#7A2A8C", dot: "bg-[#F6E3FA] border-[#B455C9]" },
  { id: "teal",     label: "Mint",      hex: "#3FB59A", bg: "#DFF6EF", fg: "#1D6E5B", dot: "bg-[#DFF6EF] border-[#3FB59A]" },
];

export const DEFAULT_NODE_COLOR = "stone";
export const DEFAULT_KEYWORD_COLOR = "forest";

export function paletteToken(id) {
  return PALETTE.find((p) => p.id === id) || PALETTE[0];
}
